export default "__VITE_ASSET__CTjQwfG5__"